var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 230,
    height: 106,
    viewBox: "0 0 230 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "EmptyState_svg__[object_Object]a",
    width: "125%",
    height: "132.1%",
    x: "-12.5%",
    y: "-12.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0534309441 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "EmptyState_svg__[object_Object]c",
    width: "125%",
    height: "132.1%",
    x: "-12.5%",
    y: "-12.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0534309441 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "EmptyState_svg__[object_Object]e",
    width: "125%",
    height: "132.1%",
    x: "-12.5%",
    y: "-12.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0534309441 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "EmptyState_svg__[object_Object]g",
    width: "125%",
    height: "132.1%",
    x: "-12.5%",
    y: "-12.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0534309441 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "EmptyState_svg__[object_Object]b",
    width: 36,
    height: 28,
    x: 15,
    y: 12,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "EmptyState_svg__[object_Object]d",
    width: 36,
    height: 28,
    x: 29,
    y: 11,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "EmptyState_svg__[object_Object]f",
    width: 36,
    height: 28,
    x: 15,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "EmptyState_svg__[object_Object]h",
    width: 36,
    height: 28,
    x: 17,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(89 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 25,
    x: -0.5,
    y: -0.5,
    fill: "#00A1E0",
    fillOpacity: 0.149,
    stroke: "#00A1E0",
    strokeOpacity: 0.4,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A1E0",
    d: "M18 4a8 8 0 110 16 8 8 0 010-16zm-3.608 11l1-5.664H14.16l-2.024 1.256.488.992 1.2-.784-.744 4.2h1.312zm5.24 0l.2-1.136h-2.304l1.44-1.128c.187-.144.36-.284.52-.42.16-.136.3-.281.42-.436a1.707 1.707 0 00.388-1.12c0-.25-.05-.473-.148-.668a1.466 1.466 0 00-.408-.496 1.811 1.811 0 00-.612-.308 2.671 2.671 0 00-.76-.104c-.533 0-.999.147-1.396.44-.397.293-.676.71-.836 1.248l1.2.248c.075-.256.19-.455.348-.596a.826.826 0 01.572-.212c.224 0 .393.055.508.164.115.11.172.257.172.444 0 .16-.057.317-.172.472a3.125 3.125 0 01-.508.512l-2.552 1.992L15.512 15h4.12zm2.176.152a2.9 2.9 0 00.848-.124c.272-.083.512-.204.72-.364.208-.16.375-.36.5-.6s.188-.52.188-.84c0-.283-.077-.53-.232-.744a1.134 1.134 0 00-.64-.432v-.016c.133-.032.267-.083.4-.152a1.363 1.363 0 00.62-.668c.067-.152.1-.327.1-.524 0-.261-.052-.487-.156-.676a1.395 1.395 0 00-.412-.468 1.777 1.777 0 00-.588-.272 2.658 2.658 0 00-.684-.088c-.437 0-.84.096-1.208.288-.368.192-.65.496-.848.912l1.072.432a1.02 1.02 0 01.348-.412.93.93 0 01.532-.148c.197 0 .353.05.468.152a.517.517 0 01.172.408c0 .25-.095.443-.284.576-.19.133-.465.2-.828.2h-.408l-.16.96h.352c.144 0 .28.012.408.036.128.024.24.064.336.12a.623.623 0 01.312.58.675.675 0 01-.244.552c-.163.133-.375.2-.636.2-.24 0-.437-.056-.592-.168a.86.86 0 01-.32-.488l-1.216.328c.064.235.159.443.284.624.125.181.279.332.46.452s.384.21.608.272c.224.061.467.092.728.092z",
    opacity: 0.254
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyState_svg__[object_Object]a)",
    xlinkHref: "#EmptyState_svg__[object_Object]b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 29,
    x: 14.5,
    y: 11.5,
    fill: "#FFF",
    stroke: "#00A1E0",
    strokeOpacity: 0.4,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A1E0",
    fillRule: "nonzero",
    d: "M31.49 21.13a3.17 3.17 0 012.283-.97c1.188 0 2.225.655 2.777 1.628.48-.212 1.01-.33 1.57-.33A3.876 3.876 0 0142 25.33a3.876 3.876 0 01-4.645 3.796 2.841 2.841 0 01-2.476 1.438c-.445 0-.866-.102-1.24-.283a3.238 3.238 0 01-2.98 1.95 3.236 3.236 0 01-3.037-2.095 3.003 3.003 0 01-2.12-5.54 3.405 3.405 0 01-.287-1.373c0-1.907 1.565-3.453 3.496-3.453 1.133 0 2.14.533 2.78 1.36"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82 60)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 25,
    x: 6.5,
    y: -0.5,
    fill: "#148CFC",
    fillOpacity: 0.162,
    stroke: "#148CFC",
    strokeOpacity: 0.397,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 25,
    x: -0.5,
    y: 18.5,
    fill: "#148CFC",
    fillOpacity: 0.156,
    stroke: "#148CFC",
    strokeOpacity: 0.397,
    opacity: 0.745,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.254,
    transform: "translate(9 22)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 2,
    y: 2,
    fill: "#148CFC",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 7.5H6h6zm0 3H6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#148CFC",
    d: "M21 5h8a4 4 0 014 4v6a4 4 0 01-4 4h-8a4 4 0 01-4-4V9a4 4 0 014-4zm-.886 9.084c.453 0 .807-.152 1.064-.455h.014a2.315 2.315 0 00-.028.371h.994a3.836 3.836 0 01.07-.679l.238-1.358a2.11 2.11 0 00.042-.427c0-.196-.037-.364-.112-.504a1.022 1.022 0 00-.305-.35 1.311 1.311 0 00-.458-.207 2.393 2.393 0 00-.581-.066c-.266 0-.536.045-.809.136-.273.091-.514.221-.724.389l.462.644c.13-.098.276-.177.437-.238.161-.06.321-.091.48-.091.173 0 .307.031.402.095.096.063.144.162.144.297v.063a.485.485 0 01-.014.098c-.29 0-.578.019-.865.056a2.86 2.86 0 00-.77.203c-.226.098-.409.236-.549.413-.14.177-.21.406-.21.686a.823.823 0 00.354.724c.104.073.221.124.35.155.128.03.253.045.374.045zm.406-.749a.688.688 0 01-.318-.074c-.096-.048-.144-.143-.144-.283 0-.107.037-.194.112-.259a.803.803 0 01.284-.154 1.69 1.69 0 01.388-.073c.145-.012.287-.018.427-.018h.098l-.035.168a.875.875 0 01-.273.494.766.766 0 01-.539.199zm4.739.749c.28 0 .537-.056.77-.168a1.9 1.9 0 00.609-.462 2.13 2.13 0 00.402-.69c.096-.263.144-.544.144-.843a1.78 1.78 0 00-.098-.598 1.285 1.285 0 00-.739-.787 1.564 1.564 0 00-.605-.113 1.411 1.411 0 00-1.113.539h-.014l.413-2.254h-1.127L22.97 14h1.036l.084-.497h.014c.107.182.265.324.472.427.208.103.436.154.683.154zm-.161-.903c-.229 0-.408-.069-.539-.206a.737.737 0 01-.196-.529 1.224 1.224 0 01.283-.784.968.968 0 01.312-.245.864.864 0 01.392-.091c.238 0 .418.071.539.213a.786.786 0 01.182.529c0 .154-.023.299-.07.434a1.106 1.106 0 01-.196.353.902.902 0 01-.707.325zm4.249.917c.299 0 .562-.048.791-.144.229-.095.434-.225.616-.388l-.532-.714a1.126 1.126 0 01-.301.224.917.917 0 01-.427.091.84.84 0 01-.34-.063.672.672 0 01-.234-.164.669.669 0 01-.137-.239.89.89 0 01-.045-.283 1.154 1.154 0 01.29-.77.98.98 0 01.739-.329c.135 0 .258.03.367.091.11.06.19.13.242.21l.707-.672a1.16 1.16 0 00-.543-.406 2.063 2.063 0 00-.745-.133 2.111 2.111 0 00-1.554.654 2.193 2.193 0 00-.588 1.502c0 .233.04.443.123.63a1.425 1.425 0 00.878.794c.21.073.441.109.693.109z",
    opacity: 0.254
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyState_svg__[object_Object]c)",
    xlinkHref: "#EmptyState_svg__[object_Object]d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 29,
    x: 28.5,
    y: 10.5,
    fill: "#FFF",
    stroke: "#148CFC",
    strokeOpacity: 0.397,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#148CFC",
    d: "M43.453 17.385H47v15.23h-3.547c-1.415 0-1.928-.147-2.445-.423a2.883 2.883 0 01-1.2-1.2c-.276-.517-.423-1.03-.423-2.444v-7.095c0-1.415.147-1.928.424-2.445a2.883 2.883 0 011.2-1.2c.516-.276 1.03-.423 2.444-.423z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4DB1FD",
    d: "M47 17.385h3.548c1.414 0 1.927.147 2.444.424.518.276.923.682 1.2 1.2.276.516.424 1.03.424 2.444V25H47v-7.615z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2FAFE",
    d: "M54.616 25v3.548c0 1.414-.148 1.927-.424 2.444a2.883 2.883 0 01-1.2 1.2c-.517.276-1.03.424-2.444.424H47V25h7.616z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(157 29)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 25,
    x: -0.5,
    y: 22.5,
    fill: "#9BADBC",
    fillOpacity: 0.15,
    stroke: "#9BADBC",
    strokeOpacity: 0.401,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B8B99",
    d: "M14 28h8a4 4 0 014 4v6a4 4 0 01-4 4h-8a4 4 0 01-4-4v-6a4 4 0 014-4zm-.886 9.084c.453 0 .807-.152 1.064-.455h.014a2.315 2.315 0 00-.028.371h.994a3.836 3.836 0 01.07-.679l.238-1.358a2.11 2.11 0 00.042-.427c0-.196-.037-.364-.112-.504a1.022 1.022 0 00-.305-.35 1.311 1.311 0 00-.458-.206 2.393 2.393 0 00-.581-.067c-.266 0-.536.046-.809.137-.273.09-.514.22-.724.388l.462.644c.13-.098.276-.177.437-.238.161-.06.321-.091.48-.091.173 0 .307.032.402.095.096.063.144.162.144.297v.063a.485.485 0 01-.014.098c-.29 0-.577.019-.864.056a2.86 2.86 0 00-.77.203c-.227.098-.41.236-.55.413-.14.177-.21.406-.21.686a.823.823 0 00.353.724c.105.073.222.124.35.155.129.03.254.045.375.045zm.406-.749a.688.688 0 01-.318-.073c-.096-.05-.144-.144-.144-.284 0-.107.037-.194.112-.259a.803.803 0 01.284-.154 1.69 1.69 0 01.388-.073c.145-.012.287-.018.427-.018h.098l-.035.168a.875.875 0 01-.273.494.766.766 0 01-.539.199zm4.739.749c.28 0 .537-.056.77-.168a1.9 1.9 0 00.609-.462 2.13 2.13 0 00.402-.69c.096-.263.144-.544.144-.843a1.78 1.78 0 00-.098-.598 1.285 1.285 0 00-.739-.788 1.564 1.564 0 00-.605-.112 1.411 1.411 0 00-1.113.539h-.014l.413-2.254h-1.127L15.97 37h1.036l.084-.497h.014c.107.182.265.324.472.427.208.103.436.154.683.154zm-.161-.903c-.229 0-.408-.069-.539-.206a.737.737 0 01-.196-.529 1.224 1.224 0 01.283-.784.968.968 0 01.312-.245.864.864 0 01.392-.091c.238 0 .418.071.539.213a.786.786 0 01.182.529c0 .154-.023.299-.07.434a1.106 1.106 0 01-.196.354.902.902 0 01-.707.325zm4.249.917c.299 0 .562-.048.791-.143.229-.096.434-.226.616-.389l-.532-.714a1.126 1.126 0 01-.301.224.917.917 0 01-.427.091.84.84 0 01-.34-.063.672.672 0 01-.234-.164.669.669 0 01-.137-.238.89.89 0 01-.045-.284 1.154 1.154 0 01.29-.77.98.98 0 01.739-.329c.135 0 .258.03.367.091.11.06.19.13.242.21l.707-.672a1.16 1.16 0 00-.543-.406 2.063 2.063 0 00-.745-.133 2.111 2.111 0 00-1.554.655 2.193 2.193 0 00-.588 1.502c0 .232.04.442.123.629a1.425 1.425 0 00.878.795c.21.072.441.108.693.108z",
    opacity: 0.254
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 25,
    x: 30.5,
    y: 13.5,
    fill: "#9BADBC",
    fillOpacity: 0.15,
    stroke: "#9BADBC",
    strokeOpacity: 0.401,
    opacity: 0.745,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B8B99",
    d: "M49 18a8 8 0 110 16 8 8 0 010-16zm-3.608 11l1-5.664H45.16l-2.024 1.256.488.992 1.2-.784-.744 4.2h1.312zm5.24 0l.2-1.136h-2.304l1.44-1.128c.187-.144.36-.284.52-.42.16-.136.3-.281.42-.436a1.707 1.707 0 00.388-1.12c0-.25-.05-.473-.148-.668a1.466 1.466 0 00-.408-.496 1.811 1.811 0 00-.612-.308 2.671 2.671 0 00-.76-.104c-.533 0-.999.147-1.396.44-.397.293-.676.71-.836 1.248l1.2.248c.075-.256.19-.455.348-.596a.826.826 0 01.572-.212c.224 0 .393.055.508.164.115.11.172.257.172.444 0 .16-.057.317-.172.472a3.125 3.125 0 01-.508.512l-2.552 1.992L46.512 29h4.12zm2.176.152a2.9 2.9 0 00.848-.124c.272-.083.512-.204.72-.364.208-.16.375-.36.5-.6s.188-.52.188-.84c0-.283-.077-.53-.232-.744a1.134 1.134 0 00-.64-.432v-.016c.133-.032.267-.083.4-.152a1.363 1.363 0 00.62-.668c.067-.152.1-.327.1-.524 0-.261-.052-.487-.156-.676a1.395 1.395 0 00-.412-.468 1.777 1.777 0 00-.588-.272 2.658 2.658 0 00-.684-.088c-.437 0-.84.096-1.208.288-.368.192-.65.496-.848.912l1.072.432a1.02 1.02 0 01.348-.412.93.93 0 01.532-.148c.197 0 .353.05.468.152a.517.517 0 01.172.408c0 .25-.095.443-.284.576-.19.133-.465.2-.828.2h-.408l-.16.96h.352c.144 0 .28.012.408.036.128.024.24.064.336.12a.623.623 0 01.312.58.675.675 0 01-.244.552c-.163.133-.375.2-.636.2-.24 0-.437-.056-.592-.168a.86.86 0 01-.32-.488l-1.216.328c.064.235.159.443.284.624.125.181.279.332.46.452s.384.21.608.272c.224.061.467.092.728.092z",
    opacity: 0.254
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyState_svg__[object_Object]e)",
    xlinkHref: "#EmptyState_svg__[object_Object]f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 29,
    x: 14.5,
    y: -0.5,
    fill: "#FFF",
    stroke: "#9BADBC",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596168",
    d: "M30.268 17a2 2 0 013.464 0H40a1 1 0 010 2h-6.268a2 2 0 01-3.464 0H26a1 1 0 010-2h4.268zm5-4a2 2 0 013.464 0H40a1 1 0 010 2h-1.268a2 2 0 01-3.464 0H26a1 1 0 110-2h9.268zm-6-4a2 2 0 013.464 0H40a1 1 0 010 2h-7.268a2 2 0 01-3.464 0H26a1 1 0 110-2h3.268z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 29)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 25,
    x: 29.5,
    y: 22.5,
    fill: "#957FFF",
    fillOpacity: 0.158,
    stroke: "#957FFF",
    strokeOpacity: 0.397,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B8B99",
    d: "M44 28h8a4 4 0 014 4v6a4 4 0 01-4 4h-8a4 4 0 01-4-4v-6a4 4 0 014-4zm-.886 9.084c.453 0 .807-.152 1.064-.455h.014a2.315 2.315 0 00-.028.371h.994a3.836 3.836 0 01.07-.679l.238-1.358a2.11 2.11 0 00.042-.427c0-.196-.037-.364-.112-.504a1.022 1.022 0 00-.304-.35 1.311 1.311 0 00-.459-.206 2.393 2.393 0 00-.581-.067c-.266 0-.535.046-.808.137-.274.09-.515.22-.725.388l.462.644c.13-.098.276-.177.437-.238.161-.06.321-.091.48-.091.173 0 .307.032.402.095.096.063.144.162.144.297v.063a.485.485 0 01-.014.098c-.29 0-.577.019-.864.056a2.86 2.86 0 00-.77.203c-.227.098-.41.236-.55.413-.14.177-.21.406-.21.686a.823.823 0 00.353.724c.105.073.222.124.35.155.129.03.254.045.375.045zm.406-.749a.688.688 0 01-.319-.073c-.095-.05-.143-.144-.143-.284 0-.107.037-.194.112-.259a.803.803 0 01.283-.154 1.69 1.69 0 01.389-.073c.145-.012.287-.018.427-.018h.098l-.035.168a.875.875 0 01-.273.494.766.766 0 01-.539.199zm4.739.749c.28 0 .537-.056.77-.168a1.9 1.9 0 00.609-.462 2.13 2.13 0 00.402-.69c.096-.263.144-.544.144-.843a1.78 1.78 0 00-.098-.598 1.285 1.285 0 00-.739-.788 1.564 1.564 0 00-.605-.112 1.411 1.411 0 00-1.113.539h-.014l.413-2.254h-1.127L45.97 37h1.036l.084-.497h.014c.107.182.265.324.472.427.208.103.436.154.683.154zm-.161-.903c-.229 0-.408-.069-.539-.206a.737.737 0 01-.196-.529 1.224 1.224 0 01.283-.784.968.968 0 01.312-.245.864.864 0 01.392-.091c.238 0 .418.071.539.213a.786.786 0 01.182.529c0 .154-.023.299-.07.434a1.106 1.106 0 01-.196.354.902.902 0 01-.707.325zm4.249.917c.299 0 .562-.048.791-.143.229-.096.434-.226.616-.389l-.532-.714a1.126 1.126 0 01-.301.224.917.917 0 01-.427.091.84.84 0 01-.34-.063.672.672 0 01-.234-.164.669.669 0 01-.137-.238.89.89 0 01-.045-.284 1.154 1.154 0 01.29-.77.98.98 0 01.739-.329c.135 0 .258.03.367.091.11.06.19.13.242.21l.707-.672a1.16 1.16 0 00-.543-.406 2.063 2.063 0 00-.745-.133 2.111 2.111 0 00-1.554.655 2.193 2.193 0 00-.588 1.502c0 .232.04.442.122.629a1.425 1.425 0 00.879.795c.21.072.441.108.693.108z",
    opacity: 0.254
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 25,
    x: -0.5,
    y: 13.5,
    fill: "#957FFF",
    fillOpacity: 0.158,
    stroke: "#957FFF",
    strokeOpacity: 0.397,
    opacity: 0.745,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B8B99",
    d: "M18 18a8 8 0 110 16 8 8 0 010-16zm-3.608 11l1-5.664H14.16l-2.024 1.256.488.992 1.2-.784-.744 4.2h1.312zm5.24 0l.2-1.136h-2.304l1.44-1.128c.187-.144.36-.284.52-.42.16-.136.3-.281.42-.436a1.707 1.707 0 00.388-1.12c0-.25-.05-.473-.148-.668a1.466 1.466 0 00-.408-.496 1.811 1.811 0 00-.612-.308 2.671 2.671 0 00-.76-.104c-.533 0-.999.147-1.396.44-.397.293-.676.71-.836 1.248l1.2.248c.075-.256.19-.455.348-.596a.826.826 0 01.572-.212c.224 0 .393.055.508.164.115.11.172.257.172.444 0 .16-.057.317-.172.472a3.125 3.125 0 01-.508.512l-2.552 1.992L15.512 29h4.12zm2.176.152a2.9 2.9 0 00.848-.124c.272-.083.512-.204.72-.364.208-.16.375-.36.5-.6s.188-.52.188-.84c0-.283-.077-.53-.232-.744a1.134 1.134 0 00-.64-.432v-.016c.133-.032.267-.083.4-.152a1.363 1.363 0 00.62-.668c.067-.152.1-.327.1-.524 0-.261-.052-.487-.156-.676a1.395 1.395 0 00-.412-.468 1.777 1.777 0 00-.588-.272 2.658 2.658 0 00-.684-.088c-.437 0-.84.096-1.208.288-.368.192-.65.496-.848.912l1.072.432a1.02 1.02 0 01.348-.412.93.93 0 01.532-.148c.197 0 .353.05.468.152a.517.517 0 01.172.408c0 .25-.095.443-.284.576-.19.133-.465.2-.828.2h-.408l-.16.96h.352c.144 0 .28.012.408.036.128.024.24.064.336.12a.623.623 0 01.312.58.675.675 0 01-.244.552c-.163.133-.375.2-.636.2-.24 0-.437-.056-.592-.168a.86.86 0 01-.32-.488l-1.216.328c.064.235.159.443.284.624.125.181.279.332.46.452s.384.21.608.272c.224.061.467.092.728.092z",
    opacity: 0.254
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyState_svg__[object_Object]g)",
    xlinkHref: "#EmptyState_svg__[object_Object]h"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 29,
    x: 16.5,
    y: -0.5,
    fill: "#FFF",
    stroke: "#957FFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#957FFF",
    fillRule: "nonzero",
    d: "M35.5 19c-5.195 0-7.776-4.012-8.418-5.183a.656.656 0 010-.634C27.724 12.013 30.305 8 35.5 8c5.195 0 7.776 4.012 8.418 5.183.11.198.11.436 0 .634C43.276 14.987 40.695 19 35.5 19zm0-9a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 5.75a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default ForwardRef;